import { Context, useContext } from 'react'

export function useRequiredContext<T>(context: Context<T | null>): NonNullable<T> {
  const value = useContext(context)
  if (value == null) throw new Error(`Required context ${context.displayName} is missing`)
  return value
}
